import { Outlet } from "react-router-dom";
import PageDepth2 from "../components/PageDepth2";
import styles from '../styles/Archive.module.css';
import data from '../data/data.json'
import classNames from "classnames/bind";
import PageTitle from "../components/PageTitle";

const cx = classNames.bind(styles);

//손해사정 자료실
export default function Archive() {

  const archiveCategory = data.category.find(
    (category) => category.path === "archive"
  )
  console.log(archiveCategory.image)
  return (
    <>
      <PageTitle
        title={archiveCategory.label}
        image={archiveCategory.image}
      />

      <PageDepth2 pagedepth2={archiveCategory.children} />

      <Outlet/>
    </>
  );
}

